import React from 'react';
import { Hyperlink } from '../../../../components/atoms/Hyperlink';
import { TextMarker } from '../../TextMarker/TextMarker';
import { ISonURL } from '../../../../types/IUrl';

type EmailLink = {
  emailLink: ISonURL;
  dfn: string;
};

export function EmailLink({ emailLink, dfn }: EmailLink) {
  return (
    <p>
      <dfn className="invisible">{dfn}: </dfn>
      {emailLink.url
        ? (
            <Hyperlink routing={false} to={emailLink.url} className="personal-data__link">
              <TextMarker text={emailLink.name} type="strong" />
            </Hyperlink>
          )
        : (
            <span>
              <TextMarker text={emailLink.name} type="strong" />
            </span>
          )}
    </p>
  );
}
